/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutomaticTranslateMissingAppsAndLabsLocalizationsResponse } from '../../models/automatic-translate-missing-apps-and-labs-localizations-response';

export interface GolabControllerAutomaticallyTranslateMissingAppsAndLabsLocalizations$Params {
}

export function golabControllerAutomaticallyTranslateMissingAppsAndLabsLocalizations(http: HttpClient, rootUrl: string, params?: GolabControllerAutomaticallyTranslateMissingAppsAndLabsLocalizations$Params, context?: HttpContext): Observable<StrictHttpResponse<AutomaticTranslateMissingAppsAndLabsLocalizationsResponse>> {
  const rb = new RequestBuilder(rootUrl, golabControllerAutomaticallyTranslateMissingAppsAndLabsLocalizations.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutomaticTranslateMissingAppsAndLabsLocalizationsResponse>;
    })
  );
}

golabControllerAutomaticallyTranslateMissingAppsAndLabsLocalizations.PATH = '/golab/automatically-translate-missing-apps-and-labs-localizations';
